import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  connect() {
    const isDark = document.documentElement.classList.contains("dark")

    const darkOptions = {
      background: isDark ? "#1f2937" : undefined,
      color: isDark ? "#f3f4f6" : undefined,
      iconColor: isDark ? undefined : undefined
    }

    const notice = this.element.querySelector("[data-flash-notice]")
    const alert = this.element.querySelector("[data-flash-alert]")

    if (notice) {
      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: notice.textContent.trim(),
        timer: 3000,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
        ...darkOptions
      })
    }

    if (alert) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: alert.textContent.trim(),
        timer: 5000,
        showConfirmButton: true,
        confirmButtonColor: "#059669",
        confirmButtonText: "Ok",
        ...darkOptions
      })
    }
  }
}
